import { render, staticRenderFns } from "./ProjectListHome.vue?vue&type=template&id=50b70d28&scoped=true&"
import script from "./ProjectListHome.vue?vue&type=script&lang=js&"
export * from "./ProjectListHome.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListHome.vue?vue&type=style&index=0&id=50b70d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b70d28",
  null
  
)

export default component.exports